import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { config } from '../ts/config';
import ItemActionsSelector, { IActionButton } from './menus/ItemActionsSelector';
import BooleanField from '../../../_common/platform/tsx/BooleanField';

import {
    IDraggableItem,
    IDraggableItemData,
    handleMenuItemDragging
} from '../../../_common/platform/ts/DragDropCommon';

import { IGlob } from '../ts/Glob';

interface IMarkedItems {
    [id: string]: boolean;
}

interface IDirsTemplatesItemProperties {
    wtid: number;
    instanceID: string;
    name: string;
    displayDirID: number;
    overwrite?: boolean;
    rename: number;
    renameLoading: IMarkedItems;
    dragDropData?: IDraggableItemData;
    markMode?: boolean;
    marked?: boolean;

    data: {
        type: string;
    };

    onShowActions?(): void;
    onHideActions?(): void;
    onMarkedChange?(value: boolean): void;

    glob: IGlob;
}

interface IState {
    nameEdit: string;
}

export default class DirsTemplatesItem extends React.Component<IDirsTemplatesItemProperties, IState> {
    private references: {
        editField?: HTMLInputElement;
        draggableItem?: HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            nameEdit: this.props.name
        };
    }

    handleDragStart = (e, ui) => {
        $(this.references.draggableItem).addClass('dragging');
    };

    handleDragStop = (e, ui) => {
        $(this.references.draggableItem).removeClass('dragging');
    };

    getDragHelper = () => {
        const clone = $(this.references.draggableItem).clone();

        clone.removeAttr('data-reactid');

        clone.find('*').each(function () {
            $(this).removeAttr('data-reactid');
        });

        clone.addClass('template-item-helper');

        return clone;
    };

    setRenameState() {
        const input = this.references.editField;
        input.focus();
        $(input).select();
    }

    componentDidMount() {
        if (this.props.dragDropData != null) {
            const constr = WidgetBase.getConstructorByName(this.props.data.type);
            if (constr == null) {
                return;
            }

            $(this.references.draggableItem)
                .draggable({
                    helper: this.getDragHelper,
                    revert: true,
                    revertDuration: 0,
                    zIndex: 6,
                    addClasses: false,
                    appendTo: $('.pdc-platform'),

                    start: this.handleDragStart,
                    stop: this.handleDragStop,

                    scope: 'workspace'
                })
                .data('payload', {
                    type: 'template',
                    data: this.props.data
                });
        }

        if (this.props.rename === this.props.wtid) {
            this.setRenameState();
        }
    }

    componentWillUnmount() {
        const constr = WidgetBase.getConstructorByName(this.props.data.type);
        if (constr == null) {
            return;
        }

        if (this.props.dragDropData != null) {
            $(this.references.draggableItem).draggable('destroy');
        }
    }

    // componentWillUpdate(nextProps, nextState) {
    // }

    componentDidUpdate(prevProps: IDirsTemplatesItemProperties, prevState: IState) {
        if (this.props.rename === this.props.wtid && prevProps.rename !== this.props.wtid) {
            this.setRenameState();
        }

        if (this.props.dragDropData != null) {
            $(this.references.draggableItem).data('data', this.props.data);
        }
    }

    componentWillReceiveProps(nextProps: IDirsTemplatesItemProperties) {
        this.setState({
            nameEdit: nextProps.name
        });
    }

    handleOnActionsClose = () => {
        if (this.props.onHideActions != null) {
            this.props.onHideActions();
        }
    };

    handleRenameChange = (e) => {
        this.setState({
            nameEdit: e.target.value
        });
    };

    handleRenameEnd = (e) => {
        this.props.glob.AppActions.templateRenameEnd(this.props.wtid, this.state.nameEdit, this.props.instanceID);

        e.preventDefault();
    };

    handleRenameClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    processDelete() {
        if (this.props.renameLoading[this.props.wtid] || this.props.wtid === this.props.rename) {
            return;
        }

        this.props.glob.DialogActions.createDialog(
            'Delete widget "' + this.props.name + '"',
            'Widget "' + this.props.name + '" will be deleted. Please, confirm this action.',
            () => {},
            () => {
                this.props.glob.AppActions.templateRemove(this.props.wtid, this.props.instanceID);
            },
            () => {},
            'confirm',
            {
                confirmTitle: null,
                cancelTitle: 'Delete'
            }
        );
    }

    processMove() {
        if (this.props.renameLoading[this.props.wtid] || this.props.wtid === this.props.rename) {
            return;
        }

        this.props.glob.DialogActions.createDialog(
            'Select a target folder for Widget "' + this.props.name + '"', //'Select a new folder for widget "' + this.props.name + '"',
            '',
            (dirid, unVarNotUsed, overwrite) => {
                this.props.glob.AppActions.templateMove(
                    this.props.wtid,
                    overwrite,
                    this.props.displayDirID,
                    dirid,
                    this.props.instanceID
                );
            },
            () => {},
            () => {},
            'templateDirSelect',
            {
                selectTitle: 'Move to selected folder',
                rootId: config.TEMPLATES_ROOT_DIR_ID,
                overwrite: this.props.overwrite || false, //VR add overwrite here
                overwriteShow: true,
                allowSelectItem: false,
                name: this.props.name
            }
        );
    }

    getActionButtons(): IActionButton[] {
        const result: IActionButton[] = [
            {
                key: 'edit',
                title: 'Edit',
                icon: 'glyphicon glyphicon-wrench'
            },
            {
                key: 'rename',
                title: 'Rename',
                icon: 'glyphicon glyphicon-pencil'
            },
            {
                key: 'move',
                title: 'Move',
                icon: 'glyphicon glyphicon-transfer'
            },
            {
                key: 'delete',
                title: 'Delete',
                icon: 'glyphicon glyphicon-remove'
            }
        ];

        return result;
    }

    handleOnActionClick = (key: string) => {
        switch (key) {
            case 'edit':
                this.props.glob.AppActions.templateShow(this.props.wtid);
                break;

            case 'rename':
                if (!this.props.renameLoading[this.props.wtid]) {
                    this.props.glob.AppActions.templateRenameStart(this.props.wtid, this.props.instanceID);
                }
                break;

            case 'move':
                this.processMove();
                break;

            case 'delete':
                this.processDelete();
                break;

            default:
                console.log('WARNING: Menu Action has no handler.');
        }
    };

    render() {
        if (this.props.data == null) {
            return;
        }

        let markCell: React.JSX.Element;

        if (this.props.markMode) {
            markCell = (
                <td className="cell-mark">
                    <BooleanField value={this.props.marked} title={''} onChange={this.props.onMarkedChange} />
                </td>
            );
        }

        const constr = WidgetBase.getConstructorByName(this.props.data.type);

        let icon: React.JSX.Element;

        if (constr != null) {
            icon = <span className={'glyphicon glyphicon-' + constr.icon}></span>;
        }

        let title;

        if (this.props.rename === this.props.wtid && !this.props.renameLoading[this.props.wtid]) {
            title = (
                <form onSubmit={this.handleRenameEnd}>
                    <input
                        ref={(input) => {
                            this.references.editField = input;
                        }}
                        value={this.state.nameEdit}
                        onClick={this.handleRenameClick}
                        onChange={() => {}} //Is added to fix red warning.
                        onInput={this.handleRenameChange}
                        onBlur={this.handleRenameEnd}
                    />
                </form>
            );
        } else {
            title = this.props.name;
        }

        return (
            <div
                key={this.props.wtid}
                className={
                    'dir-node-flat dropdown dirs-content-item' +
                    (this.props.renameLoading[this.props.wtid] ? ' loading' : '')
                }
            >
                <div
                    className={'dir-node-flat-item' + (this.props.dragDropData != null ? ' dragabble' : '')}
                    ref={(input) => {
                        this.references.draggableItem = input;
                    }}
                    //onClick={ this.handleClick }
                >
                    <table className="dir-node-flat-table">
                        <tbody>
                            <tr>
                                {markCell}

                                <td className="cell-icon">{icon}</td>

                                <td className="cell-title">{title}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ItemActionsSelector
                    className="config-button"
                    buttons={this.getActionButtons()}
                    onActionClick={this.handleOnActionClick}
                    onShow={this.props.onShowActions}
                    onClose={this.handleOnActionsClose}
                    glob={this.props.glob}
                />
            </div>
        );
    }
}
